// extracted by mini-css-extract-plugin
export default {"ninPortalContainer":"style_ninPortalContainer__iuK2m"};